import { Row, Col, Card, Divider, Table, Tag } from "antd";
import "antd/dist/antd.css";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { BACKEND_URL } from "../../../../services/backendURL";
import DashboardNewService from "../../../../services/DashboardNew/DashboardNewService";
import PartyMemberAvatar from "../../../../helpers/PartyMemberAvatar";
import moment from "moment";



const LatestTasks = ({ dashboardData }) => {
    const token = useSelector((state) => state.Member.token);
    const [loading, setLoading] = useState(false);
    const [tasks, setTasks] = useState([]);


    const tasksTableColumns = [
        {
            title: "#",
            dataIndex: "row_number",
            key: "row_number",
            align: "center",
            width: 60,
            render: (value) => <b>{value}</b>,
        },
        {
            title: "Detyra",
            dataIndex: "task",
            render: (text, record) => (
                record.task.name
            ),
            width: 400,
        },
        {
            title: "Data",
            dataIndex: "start_date",
            align: "center",
            width: 250,
            render: (text, record) => (
                moment(record.start_date).format("DD-MM-YYYY, HH:mm")
            ),
        },
        {
            title: "Progresi",
            dataIndex: "progress",
            align: "center",
            width: 200,
            render: (text, record) => (
                <Tag color={record.task_status.name === "Perfunduar" ? "green" : "magenta"}>{record.task_status.name}</Tag>
            ),
        },
        {
            title: "Krijuar nga",
            dataIndex: "created_by",
            width: 300,
            render: (text, record) => (
                <>
                    <PartyMemberAvatar
                        photo={BACKEND_URL + record.task.create_member.photo}
                        name={record.task.create_member.name}
                        surname={record.task.create_member.surname}
                        fullName={record.task.create_member.name + " " + record.task.create_member.surname}
                    />
                </>
            ),
        },
        {
            title: "Pikët",
            dataIndex: "points",
            width: 100,
            align: "center",
            render: (text, record) => (
                <Tag color="geekblue">{parseInt(record.task.points)}</Tag>
            ),
        }
    ];


    useEffect(() => {
        setLoading(true);
        DashboardNewService.getDashboardTasks(token)
            .then((response) => {
                setTasks(response.data);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
            });
    }, [token]);



    return (
        <Row gutter={24}>
            <Col span={24}>
                <Row gutter={24}>
                    <Col span={24}>
                        <Row gutter={24}>
                            <Col span={24}>
                                <Divider orientation="left" style={{ borderTopColor: "#a461d852" }} className="m-0">
                                    <h4 className="m-0" style={{ color: "#a461d8" }}>Detyrat e fundit</h4>
                                </Divider>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row gutter={24} className="mt-2">
                    <Col span={24}>
                        <Card bodyStyle={{ padding: "0px" }}>
                            <div className="table-responsive">
                                <Table
                                    size="small"
                                    columns={tasksTableColumns}
                                    rowKey="id"
                                    // bordered="true"
                                    dataSource={tasks}
                                    pagination={false}
                                    loading={loading}
                                    showHeader="true"
                                    scroll={{ x: 1200 }}
                                />
                            </div>
                        </Card>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};


export default LatestTasks;